// src/api/translations.js

import { createAuthenticatedFetch } from './types/core/common';
import type { Translation, TranslationCreate } from './types/core/translations';

// @deprecated Use imports from '@/api/types' instead
export type {
  Translation,
  TranslationCreate,
};

const api = createAuthenticatedFetch();

// Objet principal contenant toutes les fonctions
export const translations = {
  async fetchTranslations(): Promise<Translation[]> {
    return await api.get<Translation[]>('/translations/');
  },

  async createTranslation(translationData: TranslationCreate): Promise<Translation> {
    return await api.post<Translation>('/translations/', translationData);
  },

  async updateTranslation(translationId: number, translationData: Partial<TranslationCreate>): Promise<Translation> {
    return await api.put<Translation>(`/translations/${translationId}`, translationData);
  },

  async deleteTranslation(translationId: number): Promise<void> {
    await api.delete(`/translations/${translationId}`);
  }
};

// Exports des fonctions individuelles pour la rétrocompatibilité
export const fetchTranslations = (): Promise<Translation[]> => translations.fetchTranslations();
export const createTranslation = (translationData: TranslationCreate): Promise<Translation> => translations.createTranslation(translationData);
export const updateTranslation = (translationId: number, translationData: Partial<TranslationCreate>): Promise<Translation> => translations.updateTranslation(translationId, translationData);
export const deleteTranslation = (translationId: number): Promise<void> => translations.deleteTranslation(translationId);